import { GENERAL_SETTING_TYPE } from "../constants";

const generalSettingsReducer = (state = {
   hideMenu: false,
   hideInfoChat: false
}, action) => {
   switch (action.type) {
      case GENERAL_SETTING_TYPE.SHOW_OR_HIDE_MENU:
         return {
            ...state,
            hideMenu: action.payload
         }
      case GENERAL_SETTING_TYPE.SHOW_OR_HIDE_INFO_CHAT:
         return {
            ...state,
            hideInfoChat: action.payload
         }
      default:
         return state;
   }

}

export default generalSettingsReducer;